module.exports = "<span class=\"icons icons--{{ $ctrl.colorClass }} icons--{{ $ctrl.iconSize }}\"> <i class=\"fa fa-exclamation-circle\" aria-hidden=true data-ng-if=$ctrl.hasExclamation></i> <md-icon dt-icon-attributes md-svg-icon=\"{{ $ctrl.iconClass }}\"></md-icon> </span> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/icon/icon.html
// module id = isvF
// module chunks = 1